import React, { createContext, useContext } from 'react';
import { useVectorCapitalSimulatorState } from './useVectorCapitalSimulatorState';
import VectorCapitalGlobalOverlays from './VectorCapitalGlobalOverlays';

const VectorCapitalSimulatorContext = createContext(null);

function VectorCapitalSimulatorProviderInner({ children, ...props }) {
  const value = useVectorCapitalSimulatorState(props);
  return (
    <VectorCapitalSimulatorContext.Provider value={value}>
      {children}
      <VectorCapitalGlobalOverlays />
    </VectorCapitalSimulatorContext.Provider>
  );
}

export function VectorCapitalSimulatorProvider({ children, ...props }) {
  const parentCtx = useContext(VectorCapitalSimulatorContext);
  if (parentCtx) {
    return children;
  }
  return (
    <VectorCapitalSimulatorProviderInner {...props}>
      {children}
    </VectorCapitalSimulatorProviderInner>
  );
}

export function useVectorCapitalSimulator() {
  const ctx = useContext(VectorCapitalSimulatorContext);
  if (!ctx) {
    throw new Error('useVectorCapitalSimulator must be used within VectorCapitalSimulatorProvider');
  }
  return ctx;
}

/**
 * App-level wrapper — one shared Vector Capital state for /vector-capital,
 * Overview Test, and Overview dashboards with VC widgets.
 */
export function VectorCapitalAppProvider({
  children,
  user,
  isAdmin = false,
  isFullAdmin = false,
  enabled = false,
}) {
  if (!enabled || !user?.email) {
    return children;
  }
  return (
    <VectorCapitalSimulatorProvider
      user={user}
      showEquityPortfolios
      isAdmin={isAdmin}
      isFullAdmin={isFullAdmin}
    >
      {children}
    </VectorCapitalSimulatorProvider>
  );
}
